const EMAIL_BUILDER_SETTINGS_PANEL_SCROLL_MARGIN_PX = 16;

export function resolveEmailBuilderSettingsPanelScrollRoot(element: HTMLElement): HTMLElement | null {
  const sidePanelBody = element.closest(".email-builder-settings-side-panel-body");
  if (sidePanelBody instanceof HTMLElement) {
    return sidePanelBody;
  }

  const bottomSheetBody = element.closest(".email-builder-settings-bottom-sheet-body");
  if (bottomSheetBody instanceof HTMLElement) {
    return bottomSheetBody;
  }

  return null;
}

export function scrollEmailBuilderSettingsPanelContentIntoView(
  contentElement: HTMLElement,
): void {
  const scrollRoot = resolveEmailBuilderSettingsPanelScrollRoot(contentElement);
  if (!scrollRoot) {
    return;
  }

  const containerRect = scrollRoot.getBoundingClientRect();
  const contentRect = contentElement.getBoundingClientRect();
  const overflowBottom =
    contentRect.bottom - (containerRect.bottom - EMAIL_BUILDER_SETTINGS_PANEL_SCROLL_MARGIN_PX);

  if (overflowBottom > 0) {
    scrollRoot.scrollTop += overflowBottom;
  }
}

export function scrollEmailBuilderSettingsExpandedSectionIntoView(
  sectionElement: HTMLElement,
): void {
  const panel = sectionElement.querySelector(".email-builder-settings-accordion-section__panel");
  if (!(panel instanceof HTMLElement)) {
    return;
  }

  scrollEmailBuilderSettingsPanelContentIntoView(panel);
}

export function syncEmailBuilderSettingsPanelScroll(element: HTMLElement): void {
  scrollEmailBuilderSettingsPanelContentIntoView(element);
  clampEmailBuilderSettingsPanelScrollTop(element);
}

function clampEmailBuilderSettingsPanelScrollTop(element: HTMLElement): void {
  const scrollRoot = resolveEmailBuilderSettingsPanelScrollRoot(element);
  if (!scrollRoot) {
    return;
  }

  const maxScrollTop = Math.max(0, scrollRoot.scrollHeight - scrollRoot.clientHeight);
  scrollRoot.scrollTop = Math.min(scrollRoot.scrollTop, maxScrollTop);
}
